import { inject,Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { GraphDotnetService, graphql, MediaclipMutationUpdateInvoiceArgs, UpdateInvoiceInput } from 'app/shared/graph';

@Injectable({ providedIn: 'root' })
export class InvoiceService {
    private readonly graphDotnetService = inject(GraphDotnetService);


    adjustInvoiced(input: UpdateInvoiceInput): Observable<void> {
        return this.graphDotnetService.mutate<MediaclipMutationUpdateInvoiceArgs>(graphql`
                mutation updateInvoice($input: UpdateInvoiceInput!) {
                    updateInvoice(input: $input)
                }
            `,
            { input }
        ).pipe(map(result => result.updateInvoice));
    }
}
